import React, { FC, useRef } from 'react';
import { Control } from 'react-hook-form';

import { ChevronDownIcon } from '../../../../../../assets/icons/index';
import {
  ComboboxButton,
  ComboboxOptions,
  ComboboxOptionsPortalWrapper,
  FormCombobox,
  FormComboboxInput,
  FormComboboxOption,
} from '../../../../../../components/combobox/index';
import { DilutionImpactTitle } from '../../../../../../types/scenario-modeling.types';
import { FundraisingFormSchema } from '../../../fundraising-validation';

export type DilutionImpactListProps = {
  control: Control<FundraisingFormSchema>;
  index: number;
};

const DilutionImpactList: FC<DilutionImpactListProps> = ({ control, index }) => {
  return (
    <>
      {Object.entries(DilutionImpactTitle).map(([key, value]) => (
        <FormComboboxOption
          control={control}
          key={key}
          name={`pools.poolItems.${index}.type`}
          value={key}
        >
          <span className="text-sm text-gray-700">{value}</span>
        </FormComboboxOption>
      ))}
    </>
  );
};

export type DilutionImpactComboboxProps = {
  control: Control<FundraisingFormSchema>;
  index: number;
};

export const DilutionImpactCombobox: FC<DilutionImpactComboboxProps> = ({ control, index }) => {
  const inputRef = useRef<HTMLDivElement>(null);
  return (
    <FormCombobox
      className="relative w-full min-w-[130px]"
      control={control}
      name={`pools.poolItems.${index}.type`}
    >
      <div className="relative" ref={inputRef}>
        <FormComboboxInput
          className={'bg-gray-900'}
          control={control}
          customValue={(value) => (value ? DilutionImpactTitle[value] : '')}
          icon={<ChevronDownIcon className="mt-2" />}
          name={`pools.poolItems.${index}.type`}
          readOnly
          wrapperClassName="h-10"
        />
        <ComboboxButton className="absolute left-0 top-0 z-20 h-full w-full" />
      </div>
      <ComboboxOptionsPortalWrapper anchorRef={inputRef} itemsCount={2}>
        <ComboboxOptions className="z-20 h-fit max-h-[150px] w-full overflow-x-hidden">
          <DilutionImpactList control={control} index={index} />
        </ComboboxOptions>
      </ComboboxOptionsPortalWrapper>
    </FormCombobox>
  );
};
